//------------------------------------------------------------------
// Description: DSC Client Interface object. This is the client interface to DSC Server. There are 2 levels of DSC protocol:
//              messaging and communication. This interface abstracts the communication protocol. The messaging itsef is
//				handled by the application. In the case of VIL, the Conference Manager and the uScope viewer handle messaging.
//              This interface object depends on the internal communication module called g_dscConnection. All logic is contained
//              in that object.
// Author:      Kiran Saligrama
// Interface Description:
//              setDSCURI:  DSC client connects to DSC Server via Apache. This uses Apache's reverse proxy capabilities.
//                          This property contains the string used in Apache config to redirect traffic to DSC Server.
//              resetDSCConnection: Resets the internal communication object and the connection itself.
//              addDSCMessageHandler: Client of this module can use this method to add a callback routine. A message type can
//                                    be specified to restrict messages that this callback should be called on. Refer to _dscMessageTypes
//                                    for supported message types.
//                                    The set callback is called whenever a message is received from DSC Server. These could be 
//                                    responses to messages sent by the client or event updates sent by the server.
//              addDSCErrorHandler: Clients can add handler functions for errors that occur at communication level.
//              sendDSCMessage: This method is called by the client to send any message to DSC Server. This accepts the message title
//                              an XML node called Data which contains message specific data and a type. The type is used to determine
//                              whether all messages should be sent or only the latest should be sent. Refer to MessageTypes file for
//                              specific mapping.
//
// Include Order: This component depends on DSCClientUtil, DSCMessageQueue and DSCMessageTypes modules. A specific include order is
//                required.
//                  DSCMessageTypes.js
//                  DSCMessageQueue.js
//                  DSCClientUtil.js
//                  DSCClientIntf-v1.js
// 
// Date ------  Developer -- Description ----------------------------
// 22 Sept 2011 SK           Original
// 14 Oct  2011 SK           Add error handler support
// 25 Oct  2011 SK           Fix include order
//------------------------------------------------------------------

var g_dscClient =
{
	setDSCURI: function (value) { g_dscConnection.setDSCURI(value); },
	resetDSCConnection: function () { g_dscConnection.reset(); },

	addDSCMessageHandler: function (msgType, handlerFunction) 
	{
		g_dscConnection.addDSCMessageHandler(msgType, handlerFunction);
	},

	addDSCErrorHandler: function (handlerFunction)
	{
		g_dscConnection.addDSCErrorHandler(handlerFunction);
	},

	sendDSCMessage: function (msgTitle, msgDataNode, msgType) { g_dscConnection.sendDSCMessage(msgTitle, msgDataNode, msgType, undefined, undefined) }
};
